module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid36_980x860.1ba5e48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid36_980x860.jpg
// module id = q/6k
// module chunks = 0